import { render, staticRenderFns } from "./ManageAssignmentCheck.vue?vue&type=template&id=4e3c5dfa&"
import script from "./ManageAssignmentCheck.vue?vue&type=script&lang=js&"
export * from "./ManageAssignmentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports